module.exports = __webpack_public_path__ + "static/monzo-stats@2x-cd62492053c0314d28c1bd082fac935e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/monzo/monzo-stats@2x.jpg
// module id = 412
// module chunks = 3627797113349 20562973939449 33019919093843